import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
//
import { useState } from 'react';
import { fileData, fileFormat, fileThumb } from './utils';
import DownloadButton from './download-button';

// ----------------------------------------------------------------------

export default function FileThumbnail({
  file,
  tooltip,
  imageView,
  onDownload,
  sx,
  imgSx,
  imageError: externalImageError,
  setImageError: externalSetImageError,
  setValue,
  onClick,
}) {
  const { name = '', path = '', preview = '' } = fileData(file);
  
  // Use internal state if external state is not provided
  const [internalImageError, setInternalImageError] = useState(false);
  
  // Use external state if provided, otherwise use internal state
  const imageError = externalImageError !== undefined ? externalImageError : internalImageError;
  const setImageError = externalSetImageError || setInternalImageError;

  const handleImageError = () => {
    if (setValue) {
      setValue('file', '');
      setValue('images', [], { shouldValidate: true });
    }
    if (setImageError) {
      setImageError(true);
    }
  };
  const format = fileFormat(path || preview);

  const renderContent = format === 'image' && imageView && !imageError && (
    <Box
      component="img"
      src={preview}
      onClick={() => onClick && onClick(file)}
      sx={{
        width: 1,
        height: 1,

        flexShrink: 0,
        objectFit: 'cover',
        ...imgSx,
      }}
      onError={handleImageError}
    />
  );

  if (tooltip) {
    return (
      <Tooltip title={name}>
        <Stack
          flexShrink={0}
          component="span"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 'fit-content',
            height: 'inherit',
          }}
        >
          {renderContent}
          {onDownload && <DownloadButton onDownload={onDownload} />}
        </Stack>
      </Tooltip>
    );
  }

  return (
    <>
      {renderContent}
      {onDownload && <DownloadButton onDownload={onDownload} />}
    </>
  );
}

FileThumbnail.propTypes = {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imageView: PropTypes.bool,
  imgSx: PropTypes.object,
  onDownload: PropTypes.func,
  sx: PropTypes.object,
  tooltip: PropTypes.bool,
  imageError: PropTypes.bool,
  setImageError: PropTypes.func,
  setValue: PropTypes.func,
  onClick: PropTypes.func,
};
